var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 16.9341C25.5913 16.9341 27.1174 17.5662 28.2426 18.6914C29.3679 19.8167 30 21.3428 30 22.9341V29.9341H26V22.9341C26 22.4036 25.7893 21.8949 25.4142 21.5199C25.0391 21.1448 24.5304 20.9341 24 20.9341C23.4696 20.9341 22.9609 21.1448 22.5858 21.5199C22.2107 21.8949 22 22.4036 22 22.9341V29.9341H18V22.9341C18 21.3428 18.6321 19.8167 19.7574 18.6914C20.8826 17.5662 22.4087 16.9341 24 16.9341V16.9341Z",
    stroke: "#6C5CE7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 17.9341H10V29.9341H14V17.9341Z",
    stroke: "#6C5CE7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.9341C13.1046 14.9341 14 14.0387 14 12.9341C14 11.8295 13.1046 10.9341 12 10.9341C10.8954 10.9341 10 11.8295 10 12.9341C10 14.0387 10.8954 14.9341 12 14.9341Z",
    stroke: "#6C5CE7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedin);
export default __webpack_public_path__ + "static/media/icon-linkedin.354d3d90f4634d828139fe6f824ead64.svg";
export { ForwardRef as ReactComponent };